import {
	EventResultType,
	RequestEvent,
	RequestMiddleware,
	RetryEventResult,
} from "./api/ApiTypes";
import * as AuthUtils from "./util/AuthUtils";
import store from "../store";
import * as UserActions from "../store/User/User.action";
import { isErrorCode } from "./util/ErrorUtils";

const TokenMiddleware = (): RequestMiddleware => {
	return {
		[RequestEvent.Error]: async (context) => {
			if (!context.response) return;
			const data = context.response.data;

			if (data && (data.error || data.code)) {
				if (
					data.error === "Unauthorised / Bad Token" ||
					data.code === "auth/invalid-token" ||
					data.code === "auth/expired-token"
				) {
					// We can't try again if we don't have an auth token...
					if (!AuthUtils.isUserLoggedIn()) {
						return;
					}

					try {
						await AuthUtils.refreshAuthToken();
						return {
							type: EventResultType.Retry,
						} as RetryEventResult<any>;
					} catch (error) {
						if (
							!isErrorCode(error, "misc/rate-limit-reached") &&
							AuthUtils.isUserLoggedIn()
						) {
							store.dispatch(UserActions.signOut(true));
						}
					}
				}
			}

			return;
		},

		[RequestEvent.BeforeSend]: async (context) => {
			// We can't try again if we don't have an auth token...
			if (!AuthUtils.isUserLoggedIn()) {
				return;
			}

			await AuthUtils.possiblyWaitForTokenRefresh();

			// token has expired!
			const tokenMetadata = AuthUtils.getTokenMetadata();
			if (tokenMetadata && Date.now() > tokenMetadata.expiresAt) {
				await AuthUtils.refreshAuthToken();
			}
		},
	};
};

export default TokenMiddleware;
